import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setReturnCircualtionOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'

export function* getReturnCirculationOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getReturnCirculationOptions])
    const { entity } = response
    yield put(setReturnCircualtionOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getReturnCirculationOptions() error: ${e}`))
  }
}

export function* getReturnCirculationOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getReturnCirculationOptions)
}
